import React, { useContext } from "react";
import {
  Menu,
  Icon,
  MenuItem,
  ClickAwayListener,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useSelector, useDispatch } from "react-redux";
import { ChangeLanguage } from "../../actions";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ThemeSelect from "../internationalization/themeSelect";
import { MasterContext } from "../../context/master";
import {
  LANG_TURKISH,
  LANG_DEUTSCH,
  LANG_ENGLISH,
} from "../../constants/language";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  menuItem: {
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  menuItemV2: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  themeTypo: {
    marginLeft: 8,
  },
}));

const LanguageSelector = (props) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();
  const language = useSelector((state) => state.language);
  const dispatch = useDispatch();
  const context = useContext(MasterContext);
  const [open, setOpen] = React.useState(false);

  const handleClickList = (event) => {
    setOpen(!open);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    var isValidTarget = isEventTargetChildOf(event, "MuiMenu-paper");
    if (!isValidTarget) {
      setAnchorEl(null);
    }
  };

  const isEventTargetChildOf = function (event, parentClassName) {
    if (event === undefined || event === null) return false;
    var isParentsContainsPaperMenuClass =
      event.composedPath().filter((node) => {
        if (node.classList && node.classList.contains(parentClassName))
          return true;
      }).length > 0;
    return isParentsContainsPaperMenuClass;
  };

  const switchLanguage = (lang) => {
    const item = Object.fromEntries(
      Object.entries(JSON.parse(localStorage.getItem("persist:root")))
        .map((r) => r)
        .filter((r) => ["theme", "language"].includes(r[0]))
    );
    item.language = JSON.stringify(
      JSON.stringify({ Current: JSON.stringify(lang) })
    );
    var tmp = JSON.stringify(item);
    context
      .ChangeSavedPreferences(tmp)
      .then((response) => dispatch(ChangeLanguage(lang)));
    setOpen(!open);
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <ClickAwayListener onClickAway={handleClose}>
        <IconButton color="inherit" value onClick={handleClick}>
          <Icon>settings</Icon>
        </IconButton>
      </ClickAwayListener>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)}>
        <MenuItem className={classes.menuItemV2}>
          <List>
            <ListItem onClick={handleClickList}>
              <ListItemIcon>
                <Icon>translate</Icon>
              </ListItemIcon>
              <ListItemText
                primary={
                  language.Current === "tr"
                    ? "TÜRKÇE"
                    : language.Current === "en"
                    ? "ENGLISH"
                    : "DEUTSCH"
                }
              />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open}>
              <List component="div">
                <ListItem
                  className={classes.menuItemV2}
                  button
                  disabled={language.Current === LANG_TURKISH}
                  onClick={() => switchLanguage(LANG_TURKISH)}
                >
                  <ListItemText primary="Türkçe" />
                </ListItem>
                <ListItem
                  className={classes.menuItemV2}
                  button
                  disabled={language.Current === LANG_ENGLISH}
                  onClick={() => switchLanguage(LANG_ENGLISH)}
                >
                  <ListItemText primary="English" />
                </ListItem>
                {/* 
                <ListItem
                  className={classes.menuItemV2}
                  button
                  disabled={language.Current === LANG_DEUTSCH}
                  onClick={() => switchLanguage(LANG_DEUTSCH)}
                >
                  <ListItemText primary="Deutsch" />
                </ListItem>
                */}
              </List>
            </Collapse>
          </List>
        </MenuItem>
        <ThemeSelect></ThemeSelect>
        {/*<MenuItem
          style={{
            height: "76px",
          }}
          className={classes.menuItemV2}
          onClick={() => dispatch(switchTheme())}
        >
          <Typography>
            {theme === "dark"
              ? t("Switch to Light Theme")
              : t("Switch to Dark Theme")}{" "}
          </Typography>
          <Icon className={classes.themeTypo}>
            {theme === "dark" ? "brightness_5" : "brightness_4"}
          </Icon>
        </MenuItem>*/}
        <MenuItem
          style={{
            height: "76px",
          }}
          className={classes.menuItemV2}
          onClick={() => {
            localStorage.clear();
            window.location.href = "/";
          }}
        >
          <Typography>{t("Log Out")} </Typography>
          <Icon className={classes.themeTypo}>exit_to_app</Icon>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default LanguageSelector;
